<div class="my-8">
  <!-- Header with Title and Navigation -->
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-2xl font-bold">Featured Events</h2>
    
    <!-- Navigation Arrows -->
    <div class="flex gap-2">
      <button
        class="p-2 bg-gray-900 text-white rounded-full shadow-lg hover:bg-gray-700 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed"
        (click)="scrollLeft()"
        [disabled]="!canScrollLeft"
        aria-label="Scroll left"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button
        class="p-2 bg-gray-900 text-white rounded-full shadow-lg hover:bg-gray-700 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed"
        (click)="scrollRight()"
        [disabled]="!canScrollRight"
        aria-label="Scroll right"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>
  
  <!-- Events Container with Gradient Overlays -->
  <div class="relative">
    <!-- Left Gradient Overlay -->
    <div 
      class="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-white/60 to-transparent z-10 pointer-events-none transition-opacity duration-300"
      [class.opacity-0]="!canScrollLeft"
    ></div>
    
    <!-- Right Gradient Overlay -->
    <div 
      class="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white/60 to-transparent z-10 pointer-events-none transition-opacity duration-300"
      [class.opacity-0]="!canScrollRight"
    ></div>
    
    <!-- Events Container -->
    <div
      #scrollContainer
      class="flex gap-6 overflow-x-auto no-scrollbar scroll-smooth py-2"
      (scroll)="checkScrollPosition()"
      *ngIf="!loading()"
    >
      @for (event of events(); track $index) {
        <div class="flex-shrink-0 w-64">
          <hypenation-tickets-event-card
            [routerLink]="
              '/tickets/' + event.slug + '/' + event.uid + '/' + event.eventType.uid
            "
            [event]="event"
          ></hypenation-tickets-event-card>
        </div>
      }
    </div>
  </div>

  <!-- Loading Skeleton -->
  <div
    *ngIf="loading()"
    class="flex gap-6 overflow-x-auto no-scrollbar py-2"
  >
    @for (item of [1,2,3,4,5]; track $index) {
      <div class="flex-shrink-0 w-64">
        <hypenation-tickets-event-skeleton></hypenation-tickets-event-skeleton>
      </div>
    }
  </div>
</div>

